export default __webpack_public_path__ + "static/media/applause.1939815c.mp3";